import React from 'react';
import SubComponents from '../Common/SubComponent';

class DetailPageMainView extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
       //FormCard由外层渲染,故在主对象中排除掉
       const sub_cmps = this.props.sub_cmps.filter(item => {
           return item.cmp_type != 'FormCard';
       });
       return (
            <SubComponents
                {...this.props}
                formType={this.props.formType}
                sub_cmps={sub_cmps}
                onChange={this.props.onChange}
                onFocus={this.props.onFocus}
                onBlur={this.props.onBlur}
                onClick={this.props.onClick}
            />
        );
    }
}

DetailPageMainView.defaultProps = {
    'cmp_id': '',
    'cmp_name': '',
    'cmp_type': '',
    'version': '',
    'cmp_data': {
        'metaObjectName': '',
        'viewName': '',
        'sortNum': '',
        'title': '',
        'dataID': '',
        'isShowTitle': true,
        'isDefault': false
    },
    'sub_cmps': []
};

DetailPageMainView.PropTypes = {
    'cmp_id': React.PropTypes.string,
    'cmp_name': React.PropTypes.string,
    'cmp_type': React.PropTypes.string,
    'version': React.PropTypes.string,
    'cmp_data': {
        'metaObjectName': React.PropTypes.string,
        'viewName': React.PropTypes.string,
        'sortNum': React.PropTypes.string,
        'title': React.PropTypes.string,
        'dataID': React.PropTypes.string,
        'isShowTitle': true,
        'isDefault': false
    },
    'sub_cmps': []
};

DetailPageMainView.contextTypes = {
    actions: React.PropTypes.object
};

export default DetailPageMainView;



// WEBPACK FOOTER //
// ./src/components/DetailPage/DetailPageMainView.js